import "./App.css";
import logo from "./logo.svg";
import "./App.css";
import React from "react";
import Header from "./Components/Header";
import Homepage from "./Components/Homepage";
import Footer from "./Components/Footer";
import Winterclothcollection from "./Components/Winterclothcollection";
import { Route, Routes, BrowserRouter, Link } from "react-router-dom";
import Cart from "./Components/Cart";
import Summerclothcollection from "./Components/Summerclothcollection";
import Login from "./Components/Login";
import Signin from "./Components/Signin";
import Checkout from "./Components/Checkout";
import { useEffect, useState } from "react";
import Myprofile from "./Components/Myprofile";
import Aboutus from "./Components/Aboutus";
import Contact from './Components/Contact'
import Hamburger from "./Components/Hamburger";
import Offer from "./Components/Offer";
import Collection from "./Components/Collection";
function App() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("MyUser"));
    if (storedUser) {
      setUser(storedUser);
    }
  }, []);

  const updaterUser = (user) => {
    localStorage.setItem("MyUser", JSON.stringify(user));
    setUser(user);
  };
  const onLogout = () => {
    // Implement the logout logic here, which should clear the user data.
    localStorage.removeItem("MyUser");
    setUser(null); // Clear the user state.
  };

  return (
    <React.Fragment>
      <Header updaterUser={updaterUser} user={user} onLogout={onLogout} />
      
      <Routes>
        <Route path="/">
          {" "}
          
            <Route
              path="/"
              element={<Homepage updaterUser={updaterUser} />}
            ></Route>
  
            <Route
              path="/"
              element={<Signin updaterUser={updaterUser} />}
            ></Route>
        
        </Route>
        <Route path="/home" element={<Homepage />}></Route>

        <Route
          path="/login"
          element={<Login updaterUser={updaterUser} />}
        ></Route>
        <Route path="/" element={<Homepage />} />
        <Route
          path="/wintercollection"
          element={<Winterclothcollection />}
        ></Route>
        <Route path="/cart" element={<Cart></Cart>}></Route>
        <Route
          path="/summerclothcollection"
          element={<Summerclothcollection />}
        ></Route>

        <Route path="register" element={<Signin />}></Route>
        <Route path="/checkout" element={<Checkout />}></Route>
        <Route path="/myprofile" element={<Myprofile updaterUser={updaterUser}user={user} onLogout={onLogout}/>}></Route>
        <Route path="/About us" element={<Aboutus/>}></Route>
        <Route path="contact us" element={<Contact/>}></Route>
        <Route path="/offer" element={<Offer/>}> </Route>
        <Route path="/collection" element={<Collection/>}></Route>
      </Routes>
      
      <Footer></Footer>
    </React.Fragment>
  );
}

export default App;
